"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiSdk = exports.getApiSdk = void 0;
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var js_api_sdk_1 = require("@sendspark/js-api-sdk");
var axios_1 = __importDefault(require("axios"));
var api_v2_1 = require("./api-v2");
Object.defineProperty(exports, "getApiSdk", { enumerable: true, get: function () { return api_v2_1.getApiSdk; } });
var getApiSdk = function (_a) {
    var apiBaseUrl = _a.apiBaseUrl;
    var onRequest = function (configParam) {
        var newParams = configParam;
        newParams.baseURL = apiBaseUrl + "/api/v1";
        newParams.headers.accept = "application/json";
        newParams.withCredentials = false;
        return newParams;
    };
    var onRequestError = function (error) { return Promise.reject(error); };
    var axiosConfig = {
        baseURL: apiBaseUrl,
        withCredentials: false,
    };
    var axiosClient = axios_1.default.create(axiosConfig);
    axiosClient.interceptors.request.use(onRequest, onRequestError);
    return new js_api_sdk_1.DefaultApi({}, "", axiosClient);
};
var ApiSdk = /** @class */ (function () {
    function ApiSdk(apiBaseUrl) {
        var _this = this;
        this.postReaction = function (_a) { return __awaiter(_this, void 0, void 0, function () {
            var apiSdk, response;
            var campaignId = _a.campaignId, rest = __rest(_a, ["campaignId"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        apiSdk = this.apiSdk;
                        return [4 /*yield*/, apiSdk.postCampaignsCampaignidReactions(campaignId, rest)];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.deleteReaction = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var apiSdk, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        apiSdk = this.apiSdk;
                        if (!id) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, apiSdk.deleteReactionsId(id)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); };
        this.apiSdk = getApiSdk({ apiBaseUrl: apiBaseUrl });
    }
    return ApiSdk;
}());
exports.ApiSdk = ApiSdk;
